import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { DB_POSTFIX, makeUrl, momentDate, shortUrl } from "../../../utils";
import PsContext from "../../../context";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const Footer = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const context = useContext(PsContext);
  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoading(true);
    axios
      .post(`${ServiceUrl.DEPARTMENTS}?sadb=${DB_POSTFIX}`)
      .then((res) => {
        if (res.data.status === "1") {
          setDepartments(res.data.data);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error loading departments:", err);
        setLoading(false);
      });
  };

  return (
    <footer className="footer-section">
      <Container>
        {["gacw", "drsacoe", "acas"].includes(DB_POSTFIX) ? (
          <>
            <Row className="footer-top-menu">
              <Col>
                <ul className="footer-menu">
                  <li>
                    <a
                      href="https://portal.aei.edu.in/mob/#/stu/login"
                      className="text-white"
                      target="_blank"
                    >
                      Student Login
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://portal.aei.edu.in/mob/#/staff/login"
                      className="text-white"
                      target="_blank"
                    >
                      Staff Login
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://portal.aei.edu.in"
                      className="text-white"
                      target="_blank"
                    >
                      ERP Login
                    </a>
                  </li>
                  <li>
                    <a href="/about-us" className="text-white" target="_blank">
                      About
                    </a>
                  </li>
                  <li>
                    <a
                      href="/contact-us"
                      className="text-white"
                      target="_blank"
                    >
                      Contact
                    </a>
                  </li>
                </ul>
              </Col>
            </Row>

            {/*     <Row className="footer-nav-menu">
              <Col>
                <ul className="footer-menu text-white">
                  <li>
                    <a href="/course-objective">Academics</a>
                  </li>
                  <li>
                    <a href="/research-development-cell">Research</a>
                  </li>
                  <li>
                    <a href="/admission-enquiry">Admission</a>
                  </li>
                  <li>
                    <a href="/anti-ragging">Committees</a>
                  </li>
                  <li>
                    <a href="/iqac-vision-mission">IQAC</a>
                  </li>
                  <li>
                    <a href="/nirf">NIRF</a>
                  </li>
                  <li>
                    <a href="/founder-president">Management</a>
                  </li>
                  <li>
                    <a href="/gallery">Gallery</a>
                  </li>
                </ul>
              </Col>
            </Row> */}

            <Row className="footer-departments">
              <Col md={12}>
                <h5 className="dept-title">Departments</h5>
                {loading ? (
                  <Spinner animation="border" />
                ) : (
                  <div
                    className="departments-grid pb-3"
                    style={{ borderBottom: "1px solid #eeeeee4b" }}
                  >
                    {departments.map((dept, index) => (
                      <span key={index} className="dept-item">
                        <Link
                          className="text-white"
                          to={`/department/${dept.id}/${makeUrl(
                            dept.department
                          )}`}
                        >
                          {dept.department}
                        </Link>
                      </span>
                    ))}
                  </div>
                )}
              </Col>
            </Row>

            {/*    <Row className="footer-bottom-menu">
              <Col>
                <ul className="footer-menu">
                  <li>
                    <a href="/facilities">Facilities</a>
                  </li>
                  <li>
                    <a href="/library">Library</a>
                  </li>
                  <li>
                    <a href="/highlights">Highlights</a>
                  </li>
                  <li>
                    <a href="/faq">Frequently Asked Questions</a>
                  </li>
                  <li>
                    <a href="/alumni">Alumni</a>
                  </li>
                </ul>
              </Col>
            </Row> */}

            <Row
              className="footer-logo-section align-items-center pb-3"
              style={{ borderBottom: "1px solid #eeeeee4b" }}
            >
              <Col md={6}>
                <div className="d-flex justify-content-start gap-2 align-items-center mt-2">
                  <div>
                    <img
                      src="/fav_icon.png"
                      alt="DRSACPE College Logo"
                      className="college-logo"
                      style={{ borderRadius: "50%" }}
                    />
                  </div>
                  <div className="text-start ms-2">
                    <div className="footer-1 text-uppercase">
                      {context.settingValue("web_site_name")}
                    </div>
                    <div className="footer-2 my-2">Thiruchendur</div>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="d-flex justify-content-md-end justify-content-start mt-2 text-md-start text-start">
                  <div>
                    <div className="footer-1 text-uppercase">
                      Contact Information
                    </div>
                    <div className="footer-2 my-2">
                      {context.settingValue("web_site_name")} <br />
                      {context.settingValue("web_site_address_city")}
                      <br />
                      Phone: {context.settingValue("web_site_enquiry_phone")}
                      <br />
                      Email: {context.settingValue("web_site_enquiry_email")}
                      <br />
                      Website: {shortUrl}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </>
        ) : (
          <>
            <Row
              className="footer-logo-section align-items-center pb-3"
              style={{ borderBottom: "1px solid #eeeeee4b" }}
            >
              <Col md={6}>
                <div className="d-flex justify-content-start gap-2 align-items-center mt-2">
                  <div>
                    <img
                      src="/fav_icon.png"
                      alt="DRSACPE College Logo"
                      className="college-logo"
                      style={{ borderRadius: "50%" }}
                    />
                  </div>
                  <div className="text-start ms-2">
                    <div className="footer-1 text-uppercase">
                      {context.settingValue("web_site_name")}
                    </div>
                    <div className="footer-2 my-2">Thiruchendur-628 215.</div>
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="d-flex justify-content-md-end justify-content-start mt-2 text-md-start text-start">
                  <div>
                    <div className="footer-1 text-uppercase">
                      Contact Information
                    </div>
                    <div className="footer-2 my-2">
                      {context.settingValue("web_site_name")} <br />
                      {context.settingValue("web_site_address_city")}
                      <br />
                      Phone: {context.settingValue("web_site_enquiry_phone")}
                      <br />
                      Email: {context.settingValue("web_site_enquiry_email")}
                      <br />
                      Website: {shortUrl}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </>
        )}

        <Row className="mt-3">
          <Col className="text-start" md={6} style={{ fontSize: "14px" }}>
            Copyrights &copy; ({momentDate(new Date(), "YYYY")}){" "}
            {context.settingValue("web_site_name")} All rights reserved.
          </Col>
          <Col className="text-end" md={6} style={{ fontSize: "14px" }}>
            Designed and Developed by{" "}
            <a
              href="https://peacesoft.in"
              style={{
                color: `#fff`,
                fontSize: "14px",
              }}
              target="_blank"
            >
              Peace Soft Technologies
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
